import { CardMedia } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import fondo from '../../../Web Mundo/FONDO_NEW_STAKE_fcheju.png'
import ticket from '../../../Web Mundo/ticket-stake-brillo.gif'
import barril from '../../../Web Mundo/barril-animado.gif'
import cofre from '../../../Web Mundo/cofre-animado.gif'
import { Link } from 'react-router-dom'
import { ModalStakePasivo } from './ModalStakePasivo'


export const InicioStake = () => {
  const [open3, setOpen3] = useState(false);
  const handleClose3 = () => {
    setOpen3(false);
  }; 

  return (
    <Box sx={{backgroundImage: `url(${fondo})`, display:'flex', justifyContent:'start', width: '100%', height: {xs: '100%', md: '93vh'}, backgroundPosition: 'bottom', backgroundSize: 'cover'}}>
     <Box sx={{width: '70%', height: '100%'}}>
     <Box sx={{flexDirection: {xs:'column', md: 'row'}, width: '100%', height: '99%', display: 'flex', alignItems:{xs: 'center', md: 'end'}, justifyContent: 'space-evenly'}}>
        
        <Link style={{cursor: 'pointer', color: 'white', textDecoration: 'none'}} to="/game/stake/play" >
        <CardMedia
        component="img"
        sx={{ width: '240px'}}
        image={ticket}
        alt="P"
      />
        </Link>
  
               <CardMedia
        component="img"
        sx={{ cursor: 'pointer', width: '240px'}}
        image={cofre}
        alt="P"
        onClick={()=> setOpen3(true)}
      />
        <a target='_blank' style={{cursor: 'pointer', color: 'white', textDecoration: 'none'}} href='https://peakd.com/hive-131619/@bigdogbone/how-does-the-big-dog-bone-game-weekly-bet-pot-work'>


            <CardMedia
        component="img"
        sx={{ width: '240px'}}
        image={barril}
        alt="P"
      />
           </a>
        </Box>

        
     </Box>

     <ModalStakePasivo open3={open3} handleClose3={handleClose3} />
    </Box>
  )
}
